export default "__VITE_ASSET__B8LUtmV7__"